"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bootstrap = void 0;
const Container_1 = require("../DI/Container");
const BaseContainerConfig_1 = require("../DI/BaseContainerConfig");
function Bootstrap(callback, containerModules, containerConfig = new BaseContainerConfig_1.BaseContainerConfig()) {
    const container = new Container_1.Container(containerConfig);
    containerModules.forEach((module) => container.load(module));
    return callback(container);
}
exports.Bootstrap = Bootstrap;
//# sourceMappingURL=Bootstrap.js.map